import { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { accessLabelKey } from '../../../../lib/accesses'
import { Checkbox } from '../../../atoms'
import type { ApplicationTabProps } from '../applicationFormTypes'

// Keep in sync with VALID_ACCESSES in packages/admin-mobifull-api/src/accesses.ts (AGENTS.md)
export const VALID_ACCESSES = [
  'collaborators',
  'departments',
  'locations',
  'radios',
  'videoplaylists',
  'videos',
  'podcasts',
  'banners',
  'events',
  'offerings',
  'feed',
]

export const ApplicationAccessesTab = memo(
  ({ values, onChange, skeleton }: ApplicationTabProps) => {
    const { t } = useTranslation('admin-mobifull')
    const toggleAccess = useCallback(
      (access: string) => {
        onChange(
          'accesses',
          values.accesses.includes(access)
            ? values.accesses.filter(a => a !== access)
            : [...values.accesses, access],
        )
      },
      [onChange, values.accesses],
    )
    return (
      <div className="form-group">
        {/* biome-ignore lint/a11y/noLabelWithoutControl: label wraps table of checkboxes */}
        <label>{t('applications.form.accessesLabel')}</label>
        <table className="accesses-table">
          <tbody>
            {VALID_ACCESSES.map(access => (
              <tr key={access}>
                <td>
                  <label htmlFor={`access-${access}`}>{t(accessLabelKey(access))}</label>
                </td>
                <td>
                  <Checkbox
                    skeleton={skeleton}
                    id={`access-${access}`}
                    name={access}
                    checked={values.accesses.includes(access)}
                    onChange={() => toggleAccess(access)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  },
)

ApplicationAccessesTab.displayName = 'ApplicationAccessesTab'
